import React from "react";
import Dashboard from "../components/dashboard/dashboard";
import Addstaff from "../components/dashboard/staff/addstaff";
import Allstaff from "../components/dashboard/staff/allstaff";
import Addmember from "../components/dashboard/member/addmember";
import Allmembers from "../components/dashboard/member/allmembers";
import Addgroup from "../components/dashboard/group/addgroup";
import Allgroup from "../components/dashboard/group/allgroup";
import Loanapproval from "../components/dashboard/loan/loanapproval";
import Allloan from "../components/dashboard/loan/allloan";
import Memberprofile from "../components/dashboard/member/memberprofile";
import Addcollection from "../components/dashboard/collection/addcollection";
import Allcollection from "../components/dashboard/collection/allcollection";
import Reports from "../components/dashboard/reports";
import Addscheme from "../components/dashboard/master/scheme/addscheme";
import { ListScheme } from "../components/dashboard/master/scheme/listscheme";
import { ListBranch } from "../components/dashboard/master/listbranch";
import { Designation } from "../components/dashboard/master/designation";
import { ListRole } from "../components/dashboard/master/role";
import { Settings } from "../components/dashboard/settings";
import { Religion } from "../components/dashboard/master/religion";
import { Caste } from "../components/dashboard/master/caste";
import { Subcaste } from "../components/dashboard/master/subcaste";
import AddLoan from "../components/dashboard/loan/addloan";
import { DateCollection } from "../components/dashboard/collection/datecollection";
import { CollectionSheet } from "../components/dashboard/reports/collectionsheet";
import { LoanDisburse } from "../components/dashboard/reports/loandisburse";
import { Denomination } from "../components/dashboard/reports/denomination";
import { UserCreate } from "../components/dashboard/setting/usercreate";
import MemberLoan from "../components/dashboard/member/membersloan";
import { OutstandingSheet } from "../components/dashboard/reports/outstandingsheet";
import PreLoancollection from "../components/dashboard/preloan/addposting";
import { NOCSheet } from "../components/dashboard/reports/nocreport";
import ClockInOut from "../components/dashboard/attendance/clockinout";
import { AttendanceList } from "../components/dashboard/attendance/attendancelist";
import { MarkAttendance } from "../components/dashboard/attendance/markattendance";
import { LateApprovals } from "../components/dashboard/attendance/lateapprovals";
import { LeaveApprovals } from "../components/dashboard/attendance/leaveapprovals";
import { AttendanceReport } from "../components/dashboard/attendance/attendancereport";
import Addpayslip from "../components/dashboard/payslip/addpayslip";
import Allpayslip from "../components/dashboard/payslip/allpayslip";
import PayslipReport from "../components/dashboard/payslip/payslipreport";
import MyPayslip from "../components/dashboard/payslip/mypayslip";
import SalaryStructure from "../components/dashboard/payslip/salarystructure";
import BulkGenerate from "../components/dashboard/payslip/bulkgenerate";
import DeletedStaff from "../components/dashboard/staff/deletedstaff";
import DeletedMembers from "../components/dashboard/member/deletedmembers";
import DeletedGroup from "../components/dashboard/group/deletedgroup";
import DeletedLoan from "../components/dashboard/loan/deletedloan";
import SalaryReport from "../components/dashboard/reports/salaryreport";
import AddBmamReport from "../components/dashboard/bmam/addbmamreport";
import AllBmamReport from "../components/dashboard/bmam/allbmamreport";
import { BmamReport } from "../components/dashboard/reports/bmamreport";

export const dashboardroutes = [
  {
    id: 1,
    path: "/superadmin/dashboard",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 2,
    path: "/staff/addstaff",
    exact: false,
    element: <Addstaff />,
  },
  {
    id: 3,
    path: "/staff/allstaff",
    exact: false,
    element: <Allstaff />,
  },
  {
    id: 4,
    path: "/member/addmember",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 5,
    path: "/member/allmembers",
    exact: false,
    element: <Allmembers />,
  },
  {
    id: 6,
    path: "/group/addgroup",
    exact: false,
    element: <Addgroup />,
  },
  {
    id: 7,
    path: "/group/allgroup",
    exact: false,
    element: <Allgroup />,
  },
  {
    id: 8,
    path: "/master/addscheme",
    exact: false,
    element: <Addscheme />,
  },
  {
    id: 9,
    path: "/master/schemelist",
    exact: false,
    element: <ListScheme />,
  },
  {
    id: 10,
    path: "/loan/loanapproval",
    exact: false,
    element: <Loanapproval />,
  },
  {
    id: 11,
    path: "/loan/allloan",
    exact: false,
    element: <Allloan />
  },
  {
    id: 12,
    path: "/member/memberprofile/:id",
    exact: false,
    element: <Memberprofile />
  },
  {
    id: 13,
    path: "/collection/addcollection",
    exact: false,
    element: <Addcollection />
  },
  {
    id: 14,
    path: "/collection/allcollection",
    exact: false,
    element: <Allcollection />
  },
  {
    id: 15,
    path: "/master/branchlist",
    exact: false,
    element: <ListBranch />
  },
  {
    id: 16,
    path: "/master/designationlist",
    exact: false,
    element: <Designation />
  },
  {
    id: 17,
    path: "/master/rolelist",
    exact: false,
    element: <ListRole />
  },
  {
    id: 18,
    path: "/superadmin/incomeexpences",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 19,
    path: "/superadmin/income",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 20,
    path: "/superadmin/expences",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 20,
    path: "/superadmin/reports",
    exact: false,
    element: <Dashboard />,
  },
  {
    id: 21,
    path: "/master/schemedetail/:id",
    exact: false,
    element: <Addscheme />,
  },
  {
    id: 22,
    path: "/superadmin/settings",
    exact: false,
    element: <Settings />,
  },
  {
    id: 23,
    path: "/staff/staffdetail/:id",
    exact: false,
    element: <Addstaff />,
  },
  {
    id: 24,
    path: "/master/religionlist",
    exact: false,
    element: <Religion />,
  },
  {
    id: 25,
    path: "/master/castelist",
    exact: false,
    element: <Caste />,
  },
  {
    id: 26,
    path: "/master/subcastelist",
    exact: false,
    element: <Subcaste />,
  },
  {
    id: 27,
    path: "/group/groupdetail/:id",
    exact: false,
    element: <Addgroup />,
  },
  {
    id: 28,
    path: "/member/memberdetail/:id",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 29,
    path: "/loan/memberlist/:id",
    exact: false,
    element: <Allmembers />,
  },
  {
    id: 30,
    path: "/loan/addloan/:id",
    exact: false,
    element: <AddLoan />
  },
  {
    id: 31,
    path: "/collection/datewisecollection/:id",
    exact: false,
    element: <DateCollection />
  },
  {
    id: 32,
    path: "/reports/collectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 33,
    path: "/reports/topcollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 34,
    path: "/reports/summary",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 35,
    path: "/reports/loandisbursement",
    exact: false,
    element: <LoanDisburse />
  },
  {
    id: 36,
    path: "/reports/denomination",
    exact: false,
    element: <Denomination />
  },
  {
    id: 37,
    path: "/reports/dailycollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 38,
    path: "/reports/pendingcollectionsheet",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 39,
    path: "/member/groupmemberdetail/:id/:gid",
    exact: false,
    element: <Addmember />,
  },
  {
    id: 40,
    path: "/member/groupmemberprofile/:id/:gid",
    exact: false,
    element: <Memberprofile />
  },
  {
    id: 41,
    path: "/member/memberloanlist/:id/",
    exact: false,
    element: <MemberLoan />
  },
  {
    id: 42,
    path: "/reports/outstanding",
    exact: false,
    element: <OutstandingSheet />
  },
  {
    id: 43,
    path: "/employee/dashboard",
    exact: false,
    element: <Dashboard />
  },
  {
    id: 44,
    path: "/reports/staffwisecollection",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 45,
    path: "/collection/editcollection/:id/:gid",
    exact: false,
    element: <Addcollection />
  },
  {
    id: 46,
    path: "/preloan/addcollection",
    exact: false,
    element: <PreLoancollection />
  },
  {
    id: 47,
    path: "/preloan/listcollection",
    exact: false,
    element: <Allcollection />
  },
  {
    id: 48,
    path: "/reports/preloanreport",
    exact: false,
    element: <CollectionSheet />
  },
  {
    id: 49,
    path: "/reports/nocreport",
    exact: false,
    element: <NOCSheet />
  },
  {
    id: 50,
    path: "/attendance/clockinout",
    exact: false,
    element: <ClockInOut />
  },
  {
    id: 71,
    path: "/attendance/markattendance",
    exact: false,
    element: <MarkAttendance />
  },
  {
    id: 51,
    path: "/attendance/attendancelist",
    exact: false,
    element: <AttendanceList />
  },
  {
    id: 52,
    path: "/attendance/lateapprovals",
    exact: false,
    element: <LateApprovals />
  },
  {
    id: 69,
    path: "/attendance/leaveapprovals",
    exact: false,
    element: <LeaveApprovals />
  },
  {
    id: 70,
    path: "/attendance/attendancereport",
    exact: false,
    element: <AttendanceReport />
  },
  {
    id: 53,
    path: "/payslip/addpayslip",
    exact: false,
    element: <Addpayslip />,
  },
  {
    id: 54,
    path: "/payslip/allpayslip",
    exact: false,
    element: <Allpayslip />,
  },
  {
    id: 55,
    path: "/payslip/payslipdetail/:id",
    exact: false,
    element: <Addpayslip />,
  },
  {
    id: 56,
    path: "/payslip/payslipreport/:id",
    exact: false,
    element: <PayslipReport />,
  },
  {
    id: 57,
    path: "/payslip/mypayslip",
    exact: false,
    element: <MyPayslip />,
  },
  {
    id: 58,
    path: "/payslip/salarystructure",
    exact: false,
    element: <SalaryStructure />,
  },
  {
    id: 59,
    path: "/payslip/bulkgenerate",
    exact: false,
    element: <BulkGenerate />,
  },
  {
    id: 60,
    path: "/staff/deletedstaff",
    exact: false,
    element: <DeletedStaff />,
  },
  {
    id: 61,
    path: "/member/deletedmembers",
    exact: false,
    element: <DeletedMembers />,
  },
  {
    id: 62,
    path: "/group/deletedgroup",
    exact: false,
    element: <DeletedGroup />,
  },
  {
    id: 63,
    path: "/loan/deletedloan",
    exact: false,
    element: <DeletedLoan />,
  },
  {
    id: 64,
    path: "/reports/salaryreport",
    exact: false,
    element: <SalaryReport />,
  },
  {
    id: 65,
    path: "/bmam/addreport",
    exact: false,
    element: <AddBmamReport />,
  },
  {
    id: 66,
    path: "/bmam/allreport",
    exact: false,
    element: <AllBmamReport />,
  },
  {
    id: 67,
    path: "/bmam/reportdetail/:id",
    exact: false,
    element: <AddBmamReport />,
  },
  {
    id: 68,
    path: "/reports/bmamreport",
    exact: false,
    element: <BmamReport />,
  },
];
export default {
  dashboardroutes,
};
